// パリィの見た目「毛先の紫」(2026-10-10 ユーザー採用「火花は白」「白黒は毎回」)。 致命の弾き (exec) は今もこれ (配布版)。
//   普段のパリィは 2026-10-15 から「手本」(src/parry_tehon_fx.ts) が配布版の既定。 毛先の紫の普段のパリィは DEV ?parryLook=kesaki-default
//   (または ?parryLook=kesaki) で見比べられる。
//   旧 (金の炎の雲) へ戻す比較は DEV ?parryLook=old。 kesaki-shadow は不採用 (DEV ?parryLook=kesaki-shadow でだけ見られる)。
//   4回目 (2026-10-10 夜・火花) = 3回目の白黒＋すみれの髪から、白い筆の払いの筋を全部やめて、接点から散る火花に替えた。
//     ユーザー 10-10「線っぽいエフェクトはやめたい」「火花っぽく散りつつ」「(白黒は) フレーム数として長いからもっと一瞬」。
//     ZZZ をコマ送りで測った表 = docs/research/2026-10-10-zzz-parry-frames.md。 記録 = docs/research/2026-10-10-parry-spark.md。
//   3回目 (白黒＋白い筆の払い 11 本・白黒は止めの間ずっと) は git の 33d9b2b0。 2回目まで (毛先から紫の房の火) は 9e2ffe7c。
//
//   kesaki        = 3段。 時間は「弾いた瞬間から」の秒 (止めの間も数える = clock.since)。
//     ① 弾いて 0.1 秒 (6コマ) = 画面 (世界の層。HUD は抜かない) が白黒。 次の 0.1 秒で色が戻る (止めが明ける頃には白黒は 1 割ほどしか残らない)。
//        接点から火花が散る (24 粒・止めの間も動く)。 火花と髪の光は白黒の後に描くので、白黒の間も色を持つ。
//     ② 止めが明ける = 髪の光は毛先側の3分の1へ引き、白っぽさが抜けて少し明るい紫になる。 火花は弾いて 0.2〜0.38 秒で消えていく。
//     ③ 止めが明けて 0.22 秒 (弾いてから約 0.4 秒) = 普段の髪。
//     火花の色 = DEV ?kesakiSpark=white (既定 = 配布版・主人公の持ち色 = 白と白寄りのすみれ) | gold (旧の配布版の金の火の粉の色・比較用)。
//     白黒の長さ = DEV ?kesakiGrayF=<コマ> (白黒のまま保つコマ数・戻りは 6 コマ)。 既定 = 白黒なし (10-15 ユーザー「普段のパリィは白黒なしでいい」・
//       パック 1014c B-2)。 前の配布版 (6 コマ白黒) = ?kesakiGrayF=6。 致命の弾きの白黒は別 (exec_parry_slow_fx.ts)。
//   kesaki-shadow = (10-10 ユーザー「影はやっぱり変」で不採用・URL では残す) 上＋護拳の中心の宝石が灯り、二人の大きな影が奥の壁に跳ね上がる。
//
//   効く所 = パリィ (parry_spark で exec でない物)。 どのボス・どの攻撃でも同じ (技・ボスで値を変えない)。 パリィの見た目は1種類
//            (普段とジャストで分けない・台帳 combat.md 10-09)。 致命の弾き (exec) も白黒・火花・髪は同じ (寄りとスローは src/exec_parry_slow_fx.ts)。崩した瞬間 (parry_down) ・弾いて崩れた (parry_break) は今のまま。
//   FX 規則 = 線・円・輪・同心円・放射状の筋を描かない (形は塗りだけ)。 火花は「にじんだ光の粒」(速い間だけ進む向きへ少し伸びる・
//            長さは太さの 2.2 倍まで = 線に見えない)。 速い明滅をしない。 金は ?kesakiSpark=gold の火花だけ。
//
// 時間の数え方：ゲームの時計は止めの間は進まない (age = 0 のまま)。 止めの間の進み具合は state.hitStopRemaining の減り方から出す
//   (止めの長さは最初に見えた時の残りを覚える)。 止めの長さ = パリィ1種類で 150ms × (0.7 + 0.6 × 技の弾きの強さ) × 連続弾きの倍率
//   = 騎士の薙ぎ・覚醒王の噛みつきで 0.17〜0.2 秒。
import type { FxEvent } from './types'
import { execParryFxNew } from './exec_parry_slow_fx'
import {
  drawSpinePlayerSlotRegions, spinePlayerBonePoint, kickSpinePlayerPhysics, spinePlayerRapierPoints, addSpinePlayerPhysicsTime, nudgeSpinePlayerBones,
  type SpineSlotRegionPaint,
} from './spine_player'

export type KesakiLook = 'off' | 'kesaki' | 'kesaki-shadow'
export const KESAKI_LOOKS: readonly KesakiLook[] = ['off', 'kesaki', 'kesaki-shadow']
export function parseKesakiLook(v: unknown): KesakiLook | null {
  const k = typeof v === 'string' ? v.toLowerCase() : ''
  if (k === 'now' || k === 'old') return 'off'
  // kesaki-default = 前の配布版の既定 (普段のパリィも毛先の紫) を見比べる名前 (2026-10-15 に手本が既定になった)。
  if (k === 'kesaki-default') return 'kesaki'
  return (KESAKI_LOOKS as readonly string[]).includes(k) ? k as KesakiLook : null
}
let look: KesakiLook = 'kesaki'   // 既定 = 毛先の紫 (配布版も。 普段のパリィは手本が受け持つので、ここで描くのは致命の弾き)。 旧へ戻す比較は DEV ?parryLook=old
if (import.meta.env.DEV && typeof window !== 'undefined') {
  look = parseKesakiLook(new URLSearchParams(window.location.search).get('parryLook')) ?? 'kesaki'
  // 引数なしで今の見た目を返す。 知らない値は無視する。
  ;(window as any).__setParryLook = (next?: unknown): KesakiLook => { look = parseKesakiLook(next) ?? look; return look }
}
export function kesakiLook(): KesakiLook { return look }
/** テスト用。 配布版では URL も窓のフックも無いので、ここを呼ぶ物はテストだけ。 */
export function setKesakiLookForTest(next: KesakiLook): void { look = next }

type Spark = Extract<FxEvent, { kind: 'parry_spark' }>

export const KESAKI = {
  /** 止めが明けてから全部が消えるまで (秒)。 ゲームは parry_spark を 0.5 秒で消すので、それより短く。 */
  life: 0.26,
  /** 体の照らし (接点の白・床) が止めが明けてから消えるまで (秒・3コマ)。 */
  grayOut: 0.05,
  /**
   * 白黒 (弾いた瞬間からの秒)。 hold = 白黒のまま (6コマ)・back = 色が戻り切るまで (6コマ)。
   *   ZZZ の極限支援は白黒 13 コマ＋戻り 14〜17 コマ (60fps で測った) だが、白く飛んで見える強い所は最初の 6 コマ。
   *   ZZZ は白黒の間も画面が動き続けるが、こちらは止め (0.17〜0.2 秒) で絵が止まるので、同じ 13 コマでは長く見える
   *   (3回目の止めの間ずっと = 11〜12 コマに「長い」・10-10 ユーザー)。 強い所の 6 コマだけ取り、止めが明ける頃にはほぼ色を戻す。
   */
  gray: { hold: 6 / 60, back: 6 / 60 },
  /** 止めのうち、光が結び目の下まで駆け上がるのに使う割合 (最初の数コマで髪全体が光る)。 */
  climbShare: 0.3,
  /** 止めが明けてから: 光が毛先側へ引き切る (tipFront まで)・毛先の光が残る・消えていく (秒)。 白っぽさが抜けるまで。 */
  toTip: 0.05, tipHold: 0.05, tipFade: 0.12, whiteOut: 0.06,
  /** 光の先 (0 = 結び目の上・1 = 毛先＝光っていない)。 frontMin = 止めの間 (結び目のすぐ下)・tipFront = 色が戻った後 (毛先側の3分の1)。 */
  //   パリィは1種類 (台帳 combat.md 2026-10-09「1種類にする」)。普段とジャストで見た目を分けない。 致命の弾きは別扱い (このファイルの外)。
  one: { frontMin: 0.11, tipFront: 0.64, glow: 1, light: 1, tipGlow: 0.92 },
  /** 弾いた瞬間に体が接点へ押されたぶん (画面 px)。 髪とスカートが外へ置いていかれて跳ねる (弾いた最初のコマで1回)。 */
  kick: { x: 64, y: 46 },
  /** 止めの間、揺れの時計を tick の何倍で進めるか (止まった一瞬の中で髪が大きく跳ね上がる)。 */
  stopPhysicsRate: 2.2,
  /** 髪の跳ね上げ (度)。 止めの前半で上がり切り、明けて 0.28 秒で揺れに任せる。 根元の骨ほど大きく。 */
  lift: { deg: 58, ponytail1: 0.55, ponytail2: 0.45 },
} as const

/**
 * 髪の色の段 (0 = 結び目の上・1 = 毛先)。 止めの間の「白寄りのすみれ」(10-10 ユーザー・見本のまま)。
 *   根元側はやや濃いすみれ → 明るいすみれ #C9A0FF → 毛先ほど白に近い淡いすみれ #F0E6FF。 溜めの紫 #A05AD7 のような濃い紫で光らせない。
 */
export const KESAKI_HAIR_RAMP: readonly (readonly [number, readonly [number, number, number]])[] = [
  [0, [184, 140, 252]], [0.45, [201, 160, 255]], [0.8, [228, 212, 255]], [1, [240, 230, 255]],
]
/** 色が戻った後の毛先の光 (普段の毛先の紫 (136,57,169) より少し明るい・青みに寄せて溜めの紫 #A05AD7 と OKLab で約 10〜15 離す)。 */
export const KESAKI_TIP_RAMP: readonly (readonly [number, readonly [number, number, number]])[] = [
  [0, [168, 120, 248]], [0.64, [174, 128, 250]], [1, [190, 148, 255]],
]
/** 接点の光と体の照らし (白黒の間は灰色の世界の中の白)・床の照り返し・髪が背中を照らすすみれ・白い筋・宝石の光。 */
export const KESAKI_COLOR = {
  contact: [244, 240, 255], bossLit: [236, 232, 255], floor: [200, 190, 240], hairBack: [196, 158, 255],
  gem: [226, 204, 255], wall: [120, 84, 190], shadow: [8, 3, 18],
} as const

const easeOut = (t: number) => 1 - (1 - t) * (1 - t) * (1 - t)
const smooth = (t: number) => { const x = Math.max(0, Math.min(1, t)); return x * x * (3 - 2 * x) }
const clamp01 = (t: number) => Math.max(0, Math.min(1, t))

// 致命の弾き (exec) も受け持つ (2026-10-14 ユーザー答え「白黒で接点に寄ってスローにできない？」・src/exec_parry_slow_fx.ts)。
//   前の配布版 (致命の弾きは白黒なし・金の光) は DEV ?execParryFx=old。
export function kesakiOwns(f: FxEvent, l: KesakiLook = look): f is Spark {
  return l !== 'off' && f.kind === 'parry_spark' && (!f.exec || execParryFxNew())
}
/** kesakiOwns と同じ判定の真偽だけ版 (型の絞り込みをしない = 呼ぶ側の else で旧の描き方が型から消えない)。 */
export function kesakiTakes(f: FxEvent, l: KesakiLook = look): boolean { return kesakiOwns(f, l) }
/** いま効いている「毛先の紫」の弾き (一番新しい物)。 比較版が切られていれば undefined。 */
export function activeKesakiSpark(fx: readonly FxEvent[], now: number, l: KesakiLook = look): Spark | undefined {
  if (l === 'off') return undefined
  let active: Spark | undefined
  for (const f of fx) {
    if (!kesakiOwns(f, l)) continue
    const age = now - f.t
    if (age >= 0 && age < KESAKI.life && (!active || f.t >= active.t)) active = f
  }
  return active
}

// ---- 時計 ----------------------------------------------------------------------------------------
const stopLength = new WeakMap<object, number>()
export type KesakiClock = { age: number; stopP: number; inStop: boolean
  /** 弾いた瞬間からの秒 (止めの間も数える)。 白黒と火花はこれで進む (止めの間も動く)。 */
  since: number }
/** age = 止めが明けてからの秒 (止めの間は 0)。 stopP = 止めの進み (0〜1・明けた後は 1)。 since = 弾いてからの秒。 */
export function kesakiClock(spark: Spark, now: number, hitStopRemaining: number): KesakiClock {
  const age = Math.max(0, now - spark.t)
  if (age > 0 || hitStopRemaining <= 0) return { age, stopP: 1, inStop: false, since: (stopLength.get(spark) ?? 0) + age }
  const seen = Math.max(stopLength.get(spark) ?? 0, hitStopRemaining)
  stopLength.set(spark, seen)
  const stopP = seen > 0 ? clamp01(1 - hitStopRemaining / seen) : 1
  return { age: 0, stopP, inStop: true, since: stopP * seen }
}

// 白黒の長さ (DEV ?kesakiGrayF=<コマ>・白黒のまま保つコマ数。 戻りは KESAKI.gray.back のまま)。
//   既定 0 = 白黒なし (10-15・パック 1014c B-2)。 KESAKI.gray.hold (6 コマ) は前の配布版の値。
let grayHold = 0
if (import.meta.env.DEV && typeof window !== 'undefined') {
  const f = Number(new URLSearchParams(window.location.search).get('kesakiGrayF'))
  if (Number.isFinite(f) && f > 0 && f <= 30) grayHold = f / 60
}
/** いま使っている「白黒のまま保つ」秒 (撮影の記録用)。 */
export function kesakiGrayHold(): number { return grayHold }
/** テスト用。 */
export function setKesakiGrayHoldForTest(sec: number): void { grayHold = sec }

/** 画面の白黒の濃さ (0〜1)。 弾いて grayHold 秒は 1・次の KESAKI.gray.back 秒で色が戻る (止めの長さには付いていかない)。 grayHold 0 = 白黒なし。 */
export function kesakiGray(c: KesakiClock): number {
  if (grayHold <= 0) return 0
  if (c.since < grayHold) return 1
  return 1 - smooth((c.since - grayHold) / KESAKI.gray.back)
}
/** 光がどこまで上がっているか (0 = 結び目の上・1 = 毛先＝光っていない)。 */
export function kesakiHairFront(c: KesakiClock): number {
  const t = KESAKI.one
  // 止めの最初のコマで髪の半ばまで光り、climbShare までに結び目のすぐ下まで駆け上がる。
  if (c.inStop) return 0.5 - (0.5 - t.frontMin) * easeOut(clamp01(c.stopP / KESAKI.climbShare))
  if (c.age < KESAKI.toTip) return t.frontMin + (t.tipFront - t.frontMin) * smooth(c.age / KESAKI.toTip)
  const k = KESAKI.toTip + KESAKI.tipHold
  if (c.age < k) return t.tipFront
  return t.tipFront + (1 - t.tipFront) * smooth((c.age - k) / KESAKI.tipFade)
}
/** 髪の光の強さ (0〜1)。 止めの間に満ち、明けて毛先へ引く間に少し落ち、tipHold の後に滑らかに消える (明滅しない)。 */
export function kesakiHairGlow(c: KesakiClock): number {
  const g = KESAKI.one.glow, tip = KESAKI.one.tipGlow
  if (c.inStop) return g * (0.85 + 0.15 * easeOut(c.stopP))
  if (c.age < KESAKI.toTip) return g - (g - tip) * smooth(c.age / KESAKI.toTip)
  const k = KESAKI.toTip + KESAKI.tipHold
  if (c.age < k) return tip
  return tip * (1 - smooth((c.age - k) / KESAKI.tipFade))
}
/** 光の白っぽさ (1 = 白寄りのすみれ・0 = 毛先の少し明るい紫)。 */
export function kesakiHairWhite(c: KesakiClock): number {
  if (c.inStop) return 1
  return 1 - smooth(c.age / KESAKI.whiteOut)
}
/** 体の照らし (接点の白・床) の強さ。 止めの間は最大、色が戻るのと一緒に消える。 */
export function kesakiLightEnv(c: KesakiClock): number {
  if (c.inStop) return 1
  return 1 - smooth(c.age / KESAKI.grayOut)
}
/** 接点の小さな光。 止めの間は出たまま、明けて 50ms で溶ける。 */
export function kesakiContactEnv(c: KesakiClock): number {
  if (c.inStop) return 1
  const e = Math.max(0, 1 - c.age / KESAKI.grayOut)
  return e * e
}
/** 壁の影の大きさ (人物の何倍か) と濃さ (kesaki-shadow だけ)。 止めの間に跳ね上がり、明けて縮みながら消える。 */
export function kesakiShadow(c: KesakiClock): { scale: number; alpha: number } {
  const top = 2.35, base = 1.35
  if (c.inStop) {
    const p = easeOut(c.stopP)
    return { scale: base + (top - base) * p, alpha: 0.7 * p }
  }
  const sway = 1 + 0.018 * Math.sin(2 * Math.PI * 2.6 * c.age)
  return { scale: (top - (top - 1.75) * smooth(c.age / 0.24)) * sway, alpha: 0.7 * (1 - smooth(c.age / 0.24)) }
}

// ---- 火花 -------------------------------------------------------------------------------------------
function h01(n: number): number { const s = Math.sin(n * 127.1 + 311.7) * 43758.5453; return s - Math.floor(s) }

/** 火花の色 (DEV ?kesakiSpark=white|gold)。 white = 主人公の持ち色 (白と白寄りのすみれ)・gold = 今の配布版の金の火の粉の色。 */
export type KesakiSparkTint = 'white' | 'gold'
export function parseKesakiSparkTint(v: unknown): KesakiSparkTint | null {
  const k = typeof v === 'string' ? v.toLowerCase() : ''
  return k === 'white' || k === 'gold' ? k : null
}
let sparkTint: KesakiSparkTint = 'white'
if (import.meta.env.DEV && typeof window !== 'undefined') {
  sparkTint = parseKesakiSparkTint(new URLSearchParams(window.location.search).get('kesakiSpark')) ?? 'white'
  ;(window as any).__setKesakiSpark = (next?: unknown): KesakiSparkTint => { sparkTint = parseKesakiSparkTint(next) ?? sparkTint; return sparkTint }
}
export function kesakiSparkTint(): KesakiSparkTint { return sparkTint }
/** テスト用。 */
export function setKesakiSparkTintForTest(next: KesakiSparkTint): void { sparkTint = next }

type RGB = readonly [number, number, number]
/**
 * 火花の色。 core = 粒の芯・halo = 芯のまわりのにじみ (大きい粒)・small = 小さい粒 (交互に使う)。
 *   white: 芯は白、にじみは髪の光と同じ白寄りのすみれ (KESAKI_HAIR_RAMP の中ほど・毛先寄り)。
 *   gold : public/sprites/fx/parry-family/bloom/embers_*.webp の色 (芯 (240,240,216)・中 (240,192,120)・縁 (240,168,96)) から取った。
 */
export const KESAKI_SPARK_PALETTE: Record<KesakiSparkTint, { core: RGB; halo: RGB; small: readonly RGB[] }> = {
  white: { core: [255, 255, 255], halo: [201, 160, 255], small: [[240, 230, 255], [214, 186, 255]] },
  gold: { core: [255, 250, 236], halo: [240, 168, 96], small: [[255, 214, 150], [240, 168, 96]] },
}

/**
 * 火花の数と動き。 決め方は ZZZ のパリィ支援をコマ送りで測った値 (docs/research/2026-10-10-zzz-parry-frames.md)。
 *   count  : ZZZ の普段のパリィ支援 (アンビー) で1コマに見える火の粉 15〜25 粒・配布版の火の粉の絵 (大 20 前後) → 24 粒 (大 8・小 16)。
 *   speed  : ZZZ の火の粉は 0.3 秒で人物の背丈ほどまで散る。 こちらの主人公は 120px → 初速 380〜1100 px/秒・空気の抵抗 drag で
 *            0.3 秒に 48〜140px (背丈の 0.4〜1.15 倍)。 最初は速く、すぐ遅くなってふわっと漂う (ZZZ の火の粉と同じ)。
 *   life   : ZZZ は弾いて 0.3 秒でほとんど消え、0.37 秒に 2〜3 粒残る → 1 粒ずつ 0.2〜0.38 秒。
 *   gravity: ZZZ の火の粉は少しだけ落ちる → 420 px/秒² (0.3 秒で 15px 前後)。
 *   向き   : 接点から前へ広く (前 ±100° に 8 割・残りは上と後ろへ少し)。 主人公の顔の上に長く留まらないよう前へ寄せる。
 *   形     : にじんだ光の粒。 速い間だけ進む向きへ伸びる (太さの 2.2 倍まで)。 遅くなると丸い点になる (線に見せない)。
 */
export const KESAKI_SPARK = {
  count: 24, big: 8,
  speed: { min: 380, max: 1100 }, drag: 7, gravity: 420,
  life: { min: 0.2, max: 0.38 },
  /** 粒の半径 (画面 px・にじみ込み)。 */
  size: { big: [5, 7] as const, small: [2.4, 3.4] as const },
  stretchMax: 2.2,
  /** 打ち出しの遅れ (秒)。 全部が最初の 2 コマで出る (一度に弾ける)。 */
  spawn: 2 / 60,
} as const

export type SparkSpec = { ang: number; speed: number; life: number; size: number; big: boolean; delay: number; tone: number }
/** i 粒目の火花 (テストでも使う)。 向き・速さ・寿命・大きさをばらす。 */
export function kesakiSparkSpec(i: number): SparkSpec {
  const S = KESAKI_SPARK
  const big = i < S.big
  // 向き (前 = 0・画面の上がマイナス)。 8 割は前の ±100° (少し上へ寄せる)、残りは後ろ側の ±70°。
  const u = h01(i * 7.3 + 11)
  const deg = u < 0.8 ? -100 + 200 * h01(i * 3.1 + 2) - 12 : 180 + (h01(i * 5.9 + 4) - 0.5) * 140
  const v = h01(i * 4.7 + 3)
  const range = big ? S.size.big : S.size.small
  return {
    ang: deg * Math.PI / 180,
    speed: S.speed.min + (S.speed.max - S.speed.min) * (big ? 0.35 + 0.65 * v : v),
    life: S.life.min + (S.life.max - S.life.min) * h01(i * 6.1 + 5),
    size: range[0] + (range[1] - range[0]) * h01(i * 2.3 + 6),
    big,
    delay: S.spawn * h01(i * 8.9 + 7),
    tone: i % 2,
  }
}
/** 火花1粒の位置 (接点からの px・前 = +x)・速さ (px/秒)・濃さ。 t = 弾いてからの秒。 出る前・消えた後は null。 */
export function kesakiSparkAt(spec: SparkSpec, t: number): { x: number; y: number; vx: number; vy: number; alpha: number; scale: number } | null {
  const S = KESAKI_SPARK
  const lt = t - spec.delay
  if (lt < 0 || lt >= spec.life) return null
  const k = S.drag, e = Math.exp(-k * lt)
  const ux = Math.cos(spec.ang), uy = Math.sin(spec.ang)
  const d = spec.speed * (1 - e) / k
  const g = S.gravity
  const p = lt / spec.life
  // 出た最初の 1 コマで満ち、あとは単調に消える (明滅しない)。
  const alpha = Math.min(1, lt / (1 / 60)) * Math.pow(1 - p, 0.9)
  return {
    x: ux * d, y: uy * d + 0.5 * g * lt * lt,
    vx: ux * spec.speed * e, vy: uy * spec.speed * e + g * lt,
    alpha, scale: 1 - 0.3 * p,
  }
}
/** 全部の火花が消えるまでの秒 (弾いてから)。 */
export const KESAKI_SPARK_END = KESAKI_SPARK.spawn + KESAKI_SPARK.life.max

/**
 * 接点から散る火花。 世界座標の ctx で、白黒の後 (世界の層の最後・HUD の前) に描く = 白黒の間も色を持つ。
 *   形は塗りだけ (放射状のにじみを、進む向きへ少し伸ばして fillRect)。 facing = 主人公の向き (前 = ボスの方)。
 */
export function drawKesakiSparks(ctx: CanvasRenderingContext2D, spark: Spark, c: KesakiClock, facing: 1 | -1, tint: KesakiSparkTint = sparkTint): void {
  if (c.since >= KESAKI_SPARK_END) return
  const P = KESAKI_SPARK_PALETTE[tint]
  const rgba = (col: RGB, a: number) => `rgba(${col[0]},${col[1]},${col[2]},${Math.max(0, Math.min(1, a)).toFixed(3)})`
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  for (let i = 0; i < KESAKI_SPARK.count; i++) {
    const spec = kesakiSparkSpec(i)
    const at = kesakiSparkAt(spec, c.since)
    if (!at || at.alpha <= 0.01) continue
    const x = spark.x + at.x * facing, y = spark.y + at.y
    const vx = at.vx * facing, vy = at.vy
    const v = Math.hypot(vx, vy)
    // 進む向きへの伸び: 速い間だけ (秒速 600px で最大)。 遅くなると丸い点。
    const stretch = 1 + (KESAKI_SPARK.stretchMax - 1) * Math.min(1, v / 600)
    const r = spec.size * at.scale
    ctx.save()
    ctx.translate(x, y)
    ctx.rotate(Math.atan2(vy, vx))
    ctx.scale(stretch, 1)
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, r)
    if (spec.big) {
      // 芯をはっきり (明るい所を小さく締める)・にじみは薄く短く = 花びらのようなぼけた塊に見せない。
      g.addColorStop(0, rgba(P.core, at.alpha))
      g.addColorStop(0.28, rgba(P.core, 0.95 * at.alpha))
      g.addColorStop(0.42, rgba(P.halo, 0.6 * at.alpha))
      g.addColorStop(0.7, rgba(P.halo, 0.16 * at.alpha))
      g.addColorStop(1, rgba(P.halo, 0))
    } else {
      const col = P.small[spec.tone % P.small.length]
      g.addColorStop(0, rgba(P.core, 0.95 * at.alpha))
      g.addColorStop(0.3, rgba(col, 0.85 * at.alpha))
      g.addColorStop(0.65, rgba(col, 0.2 * at.alpha))
      g.addColorStop(1, rgba(col, 0))
    }
    ctx.fillStyle = g
    ctx.fillRect(-r, -r, r * 2, r * 2)
    ctx.restore()
  }
  ctx.restore()
}

let grayScratch: HTMLCanvasElement | undefined
/**
 * 画面を白黒にする (amount = 0〜1)。 それまでに描いた物 (背景・床・ボス・主人公・FX) を写し取って、色を抜いて描き戻す。
 *   世界の層の最後 (HUD の前) に呼ぶ。 明暗と線は残す (少しだけ明るく・締める)。 弾き崩しの白黒 (render.ts drawParryBreakScreen) と同じ作り。
 */
export function applyKesakiGray(ctx: CanvasRenderingContext2D, amount: number): void {
  if (amount <= 0.003 || typeof document === 'undefined') return
  const cv = ctx.canvas
  if (!cv || cv.width <= 0) return
  grayScratch ??= document.createElement('canvas')
  const sc = grayScratch
  if (sc.width !== cv.width || sc.height !== cv.height) { sc.width = cv.width; sc.height = cv.height }
  const s = sc.getContext('2d')
  if (!s) return
  s.setTransform(1, 0, 0, 1, 0, 0); s.globalCompositeOperation = 'copy'; s.drawImage(cv, 0, 0)
  ctx.save()
  ctx.setTransform(1, 0, 0, 1, 0, 0)
  ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over'
  ctx.filter = `grayscale(${amount.toFixed(3)}) brightness(${(1 + 0.1 * amount).toFixed(3)}) contrast(${(1 + 0.12 * amount).toFixed(3)})`
  ctx.drawImage(sc, 0, 0)
  ctx.restore()
}

// ---- 体を照らす ------------------------------------------------------------------------------------
type Light = { x: number; y: number; radius: number; color: readonly [number, number, number]; alpha: number; face: number; shift: number
  /** 1 より大きいと同じ照らしをもう一度重ねる (見本並みの強い照り返し)。 */
  gain?: number }
type Role = 'boss' | 'player'
const bodyCanvas: Partial<Record<Role, HTMLCanvasElement>> = {}
const bodyCaptured: Partial<Record<Role, number>> = {}
let rimCanvas: HTMLCanvasElement | undefined
let frameSerial = 0
/** 1コマの始めに1回呼ぶ (壁の影が「前のコマの姿」を使ってよいかの見分けに使う)。 */
export function beginKesakiFrame(): void { frameSerial++ }

/** 重さの計器 (DEV の撮影が読む・描画には影響しない)。 */
export const kesakiCost = { bodyMs: 0, hairMs: 0, shadowMs: 0, frames: 0 }
const now = () => (typeof performance !== 'undefined' ? performance.now() : 0)

function sizeLike(c: HTMLCanvasElement, ref: HTMLCanvasElement): void {
  if (c.width !== ref.width) c.width = ref.width
  if (c.height !== ref.height) c.height = ref.height
}
/** 体を1回だけ描き (姿・変換はそのまま)、光の来た側だけを照らす。 光ごとに体の形を色で塗り、光から離した写しを引いて縁を残す。 */
export function drawKesakiLitBody(ctx: CanvasRenderingContext2D, role: Role, drawBody: (target: CanvasRenderingContext2D) => void,
  bodyX: number, bodyY: number, lights: () => readonly Light[]): void {
  if (typeof document === 'undefined') { drawBody(ctx); return }
  const t0 = now()
  const body = (bodyCanvas[role] ??= document.createElement('canvas'))
  sizeLike(body, ctx.canvas)
  const b = body.getContext('2d')!, m = ctx.getTransform()
  b.resetTransform(); b.clearRect(0, 0, body.width, body.height); b.save(); b.setTransform(m); drawBody(b); b.restore()
  bodyCaptured[role] = frameSerial
  ctx.save(); ctx.resetTransform(); ctx.drawImage(body, 0, 0); ctx.restore()
  if (import.meta.env.DEV) kesakiCost.bodyMs += now() - t0
  drawKesakiBodyLights(ctx, role, bodyX, bodyY, lights())
}
/**
 * このコマで drawKesakiLitBody が描いた体 (role) を、そのまま alpha の濃さでもう一度描く (上に重ねた光の中から輪郭を読ませる・
 *   普段のパリィ「手本」の src/parry_tehon_fx.ts tehonVeilAlpha)。 このコマの体が無ければ何もせず false。
 */
export function redrawKesakiBody(ctx: CanvasRenderingContext2D, role: Role, alpha: number): boolean {
  const body = bodyCanvas[role]
  if (typeof document === 'undefined' || !body || bodyCaptured[role] !== frameSerial || alpha <= 0.003) return false
  ctx.save(); ctx.resetTransform(); ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = Math.min(1, alpha)
  ctx.drawImage(body, 0, 0)
  ctx.restore()
  return true
}
/**
 * このコマで drawKesakiLitBody が描いた体 (role) の形を、色で塗りつぶして alpha の濃さで重ねる (光で体を一瞬隠す・
 *   主人公の受け身 src/ukemi.ts ukemiCoverAlpha)。 加算で重ね、形の内側だけ光る。 このコマの体が無ければ何もせず false。
 */
export function fillKesakiBody(ctx: CanvasRenderingContext2D, role: Role, color: readonly [number, number, number], alpha: number): boolean {
  const body = bodyCanvas[role]
  if (typeof document === 'undefined' || !body || bodyCaptured[role] !== frameSerial || alpha <= 0.003) return false
  rimCanvas ??= document.createElement('canvas'); sizeLike(rimCanvas, ctx.canvas)
  const r = rimCanvas.getContext('2d')!
  r.resetTransform(); r.globalAlpha = 1; r.globalCompositeOperation = 'source-over'; r.clearRect(0, 0, rimCanvas.width, rimCanvas.height)
  r.drawImage(body, 0, 0)
  r.globalCompositeOperation = 'source-in'; r.fillStyle = `rgb(${color[0]},${color[1]},${color[2]})`; r.fillRect(0, 0, rimCanvas.width, rimCanvas.height)
  r.globalCompositeOperation = 'source-over'
  ctx.save(); ctx.resetTransform(); ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = Math.min(1, alpha)
  ctx.drawImage(rimCanvas, 0, 0)
  ctx.restore()
  return true
}
/**
 * このコマで drawKesakiLitBody が描いた体 (role) の、光の来た側の縁を照らす。 体を描いた時と同じ変換の ctx で呼ぶ。
 *   白黒にした後で色の照り返し (髪が背中を照らすすみれ) を乗せ直すのにも使う。 このコマの体が無ければ何もしない。
 */
export function drawKesakiBodyLights(ctx: CanvasRenderingContext2D, role: Role, bodyX: number, bodyY: number, lights: readonly Light[]): void {
  const body = bodyCanvas[role]
  if (typeof document === 'undefined' || !body || bodyCaptured[role] !== frameSerial) return
  const t0 = now()
  rimCanvas ??= document.createElement('canvas'); sizeLike(rimCanvas, ctx.canvas)
  const r = rimCanvas.getContext('2d')!, m = ctx.getTransform()
  const W = body.width, H = body.height
  const center = m.transformPoint({ x: bodyX, y: bodyY })
  const unit = Math.hypot(m.a, m.b)
  for (const L of lights) {
    if (L.alpha <= 0.003) continue
    const c = m.transformPoint({ x: L.x, y: L.y })
    const R = L.radius * unit
    const x0 = Math.max(0, Math.floor(c.x - R)), y0 = Math.max(0, Math.floor(c.y - R))
    const x1 = Math.min(W, Math.ceil(c.x + R)), y1 = Math.min(H, Math.ceil(c.y + R))
    if (x1 <= x0 || y1 <= y0) continue
    const bw = x1 - x0, bh = y1 - y0
    const d = Math.hypot(c.x - center.x, c.y - center.y) || 1
    const nx = (c.x - center.x) / d, ny = (c.y - center.y) / d
    r.resetTransform(); r.globalAlpha = 1; r.globalCompositeOperation = 'source-over'; r.clearRect(x0, y0, bw, bh)
    r.drawImage(body, x0, y0, bw, bh, x0, y0, bw, bh)
    // 光から離した写しを引く = 光に向いた縁だけ満ち、内側は face の濃さで薄く残る (照らされた面)。
    r.globalCompositeOperation = 'destination-out'; r.globalAlpha = 1 - L.face
    const sx = nx * L.shift * unit, sy = ny * L.shift * unit
    r.drawImage(body, x0, y0, bw, bh, x0 - sx, y0 - sy, bw, bh)
    r.globalAlpha = 1
    r.globalCompositeOperation = 'source-in'; r.fillStyle = `rgb(${L.color[0]},${L.color[1]},${L.color[2]})`; r.fillRect(x0, y0, bw, bh)
    // 光からの距離で落とす (縁を持たないにじみ)。
    r.globalCompositeOperation = 'destination-in'
    const radial = r.createRadialGradient(c.x, c.y, 0, c.x, c.y, R)
    for (let i = 0; i <= 8; i++) radial.addColorStop(i / 8, `rgba(0,0,0,${Math.pow(1 - i / 8, 1.5)})`)
    r.fillStyle = radial; r.fillRect(x0, y0, bw, bh)
    // 体の向こう側 (光から遠い半分) は暗いまま。
    const facing = r.createLinearGradient(center.x - nx * 6 * unit, center.y - ny * 6 * unit, center.x + nx * 10 * unit, center.y + ny * 10 * unit)
    facing.addColorStop(0, 'rgba(0,0,0,0)'); facing.addColorStop(1, 'rgba(0,0,0,1)')
    r.fillStyle = facing; r.fillRect(x0, y0, bw, bh)
    r.globalCompositeOperation = 'source-over'
    ctx.save(); ctx.resetTransform(); ctx.globalCompositeOperation = 'lighter'
    ctx.globalAlpha = Math.min(1, L.alpha); ctx.drawImage(rimCanvas, x0, y0, bw, bh, x0, y0, bw, bh)
    const extra = L.alpha * ((L.gain ?? 1) - 1)
    if (extra > 0.01) { ctx.globalAlpha = Math.min(1, extra); ctx.drawImage(rimCanvas, x0, y0, bw, bh, x0, y0, bw, bh) }
    ctx.globalAlpha = 0.45 * L.alpha; ctx.filter = `blur(${(2 * unit).toFixed(1)}px)`
    ctx.drawImage(rimCanvas, x0, y0, bw, bh, x0, y0, bw, bh)
    ctx.restore()
  }
  if (import.meta.env.DEV) kesakiCost.bodyMs += now() - t0
}

/** 接点の光 (白)。 光の来た方向として二人を照らす (白黒の間は灰色の世界の中の白・色が戻るのと一緒に消える)。 */
export function kesakiContactLight(spark: Spark, c: KesakiClock, role: Role = 'boss'): Light {
  // 主人公側は弱く・狭く (接点が顔の高さなので、強いと黒髪の頭まで白く飛ぶ・見本の頭は黒いまま)。
  return { x: spark.x, y: spark.y, radius: role === 'boss' ? 170 : 110, color: role === 'boss' ? KESAKI_COLOR.bossLit : KESAKI_COLOR.contact,
    alpha: KESAKI.one.light * kesakiLightEnv(c) * (role === 'boss' ? 1 : 0.4), face: role === 'boss' ? 0.12 : 0.04, shift: 4, gain: 1 }
}

// ---- 主人公の髪 -----------------------------------------------------------------------------------
const HAIR_SLOTS = ['ponytail', 'ponytail_h1', 'ponytail_h2'] as const
const hairScratch: Record<string, { col: HTMLCanvasElement; glow: HTMLCanvasElement }> = {}
type Ramp = readonly (readonly [number, readonly [number, number, number]])[]
function rampAt(R: Ramp, s: number): [number, number, number] {
  if (s <= R[0][0]) return [...R[0][1]] as [number, number, number]
  for (let i = 1; i < R.length; i++) {
    if (s <= R[i][0]) {
      const k = (s - R[i - 1][0]) / (R[i][0] - R[i - 1][0])
      return [0, 1, 2].map(j => Math.round(R[i - 1][1][j] + (R[i][1][j] - R[i - 1][1][j]) * k)) as [number, number, number]
    }
  }
  return [...R[R.length - 1][1]] as [number, number, number]
}
/** 髪の s の所の光の色。 white = 1 で白寄りのすみれ、0 で毛先の少し明るい紫。 */
export function kesakiHairColor(s: number, white: number): [number, number, number] {
  const a = rampAt(KESAKI_HAIR_RAMP, s), b = rampAt(KESAKI_TIP_RAMP, s)
  return [0, 1, 2].map(j => Math.round(b[j] + (a[j] - b[j]) * white)) as [number, number, number]
}
/** 髪の s (0 = 結び目の上・1 = 毛先) の所の、光の濃さ (0〜1)。 front より毛先側が光る (境目は髪の長さの 1 割でぼかす)。 */
export function kesakiHairLit(s: number, front: number): number {
  return smooth((s - front + 0.04) / 0.1)
}

/** 主人公の足元と向き (描いた位置)。 */
export type PlayerFoot = { x: number; y: number; facing: 1 | -1 }
function toWorld(foot: PlayerFoot, p: { x: number; y: number }): { x: number; y: number } {
  return { x: foot.x + foot.facing * p.x, y: foot.y - p.y }
}
/** 主人公の光 (接点の白・宝石)。 髪の照り返しは kesakiHairBackLight (白黒の後に色で乗せ直す)。 */
export function kesakiPlayerLights(spark: Spark, c: KesakiClock, foot: PlayerFoot, withGem: boolean): Light[] {
  const lights: Light[] = [kesakiContactLight(spark, c, 'player')]
  if (withGem) {
    const g = kesakiGemPoint(foot)
    if (g) lights.push({ x: g.x, y: g.y + 4, radius: 40, color: KESAKI_COLOR.gem, alpha: 0.85 * kesakiGemEnv(c), face: 0.08, shift: 2 })
  }
  return lights
}
/** 光る髪が照らす うなじ・肩・背中の縁 (すみれ)。 白っぽさと一緒に消える (見本の中のコマには照り返しが無い)。 体を描いた後に呼ぶ。 */
export function kesakiHairBackLight(c: KesakiClock, foot: PlayerFoot): Light[] {
  const mid = spinePlayerBonePoint('ponytail2', 0)
  const a = kesakiHairGlow(c) * kesakiHairWhite(c)
  if (!mid || a <= 0.01) return []
  const p = toWorld(foot, mid)
  return [{ x: p.x, y: p.y, radius: 58, color: KESAKI_COLOR.hairBack, alpha: 0.85 * a, face: 0.05, shift: 2.5 }]
}

/**
 * 髪を光らせる。 主人公を描いた後 (同じコマ) に、世界座標の ctx で呼ぶ。 白黒のコマでは白黒にした後に呼ぶ (髪だけ色を持つ)。
 *   髪の絵の3枚を、描いたコマと同じ変換で塗り直す (光の形 = 髪の形)。 髪の外へ伸ばさない (にじみは数 px だけ)。
 */
export function drawKesakiHair(ctx: CanvasRenderingContext2D, _spark: Spark, c: KesakiClock, foot: PlayerFoot): void {
  if (typeof document === 'undefined') return
  const t0 = now()
  const front = kesakiHairFront(c), glow = kesakiHairGlow(c), white = kesakiHairWhite(c)
  if (glow > 0.01 && front < 0.999) {
    ctx.save()
    ctx.translate(foot.x, foot.y)
    ctx.scale(foot.facing, 1)
    drawSpinePlayerSlotRegions(ctx, HAIR_SLOTS, (rc, region) => paintHairPiece(rc, region, front, glow, white))
    ctx.restore()
  }
  if (import.meta.env.DEV) kesakiCost.hairMs += now() - t0
  if (import.meta.env.DEV && kesakiDebug.wantMask) drawHairMask(ctx, foot)
}

/** 撮影の測り用 (DEV): 髪の形 (このコマの3枚) と主人公の体の絵。 描画には影響しない。 wantMask を立てた時だけ髪の形を描く。 */
export const kesakiDebug = {
  wantMask: false,
  hairMask: null as HTMLCanvasElement | null,
  playerBody: (): HTMLCanvasElement | null => bodyCanvas.player ?? null,
}
function drawHairMask(ctx: CanvasRenderingContext2D, foot: PlayerFoot): void {
  const m = (kesakiDebug.hairMask ??= document.createElement('canvas'))
  sizeLike(m, ctx.canvas)
  const g = m.getContext('2d')!
  g.resetTransform(); g.clearRect(0, 0, m.width, m.height)
  g.setTransform(ctx.getTransform()); g.translate(foot.x, foot.y); g.scale(foot.facing, 1)
  drawSpinePlayerSlotRegions(g, HAIR_SLOTS, (rc, r) => rc.drawImage(r.image, r.sx, r.sy, r.w, r.h, 0, 0, Math.ceil(r.w), Math.ceil(r.h)))
  g.resetTransform()
}

function paintHairPiece(ctx: CanvasRenderingContext2D, r: SpineSlotRegionPaint, front: number, glow: number, white: number): void {
  const w = Math.ceil(r.w), h = Math.ceil(r.h)
  const sc = (hairScratch[r.slot] ??= { col: document.createElement('canvas'), glow: document.createElement('canvas') })
  for (const c of [sc.col, sc.glow]) { if (c.width !== w) c.width = w; if (c.height !== h) c.height = h }
  const col = sc.col.getContext('2d')!, gl = sc.glow.getContext('2d')!
  // 色の段：行 y の髪の s = (rowTop + y) / 元の高さ。
  const color = col.createLinearGradient(0, 0, 0, h), light = gl.createLinearGradient(0, 0, 0, h)
  let any = false
  for (let i = 0; i <= 12; i++) {
    const s = (r.rowTop + h * i / 12) / r.originalHeight
    const lit = kesakiHairLit(s, front) * glow
    if (lit > 0.01) any = true
    const [cr, cg, cb] = kesakiHairColor(s, white)
    // 白っぽい間は髪の絵をほぼ覆う (筋が少し透ける)。 色が戻った後は髪の紫に光を重ねる程度。
    color.addColorStop(i / 12, `rgba(${cr},${cg},${cb},${((0.86 + 0.08 * white) * lit).toFixed(3)})`)
    light.addColorStop(i / 12, `rgba(${cr},${cg},${cb},${lit.toFixed(3)})`)
  }
  if (!any) return
  // 塗り直し：髪の絵の上に段の色を乗せる (絵の筋が少し透ける)。
  col.globalCompositeOperation = 'source-over'; col.clearRect(0, 0, w, h)
  col.drawImage(r.image, r.sx, r.sy, r.w, r.h, 0, 0, w, h)
  col.globalCompositeOperation = 'source-atop'; col.fillStyle = color; col.fillRect(0, 0, w, h)
  // 光：光っている所だけの形 (内側から光る分)。
  gl.globalCompositeOperation = 'source-over'; gl.clearRect(0, 0, w, h)
  gl.drawImage(r.image, r.sx, r.sy, r.w, r.h, 0, 0, w, h)
  gl.globalCompositeOperation = 'source-in'; gl.fillStyle = light; gl.fillRect(0, 0, w, h)
  ctx.save()
  ctx.drawImage(sc.col, 0, 0, w, h)
  ctx.globalCompositeOperation = 'lighter'
  // 内側から光る (髪の絵の座標で数 px のにじみ・画面では 1〜2 px)。
  ctx.globalAlpha = 0.5 + 0.1 * white
  ctx.filter = 'blur(4px)'
  ctx.drawImage(sc.glow, 0, 0, w, h)
  ctx.restore()
}

/**
 * 弾いた最初のコマで1回だけ、髪とスカートの揺れへ「体が接点へ押された」を足す。 止めの間は体のアニメを止めたまま、
 *   揺れの時計だけをゲームの tick ぶん (hitStopRemaining の減り) 進める = 止まった一瞬の中で髪だけが跳ね上がる。
 *   主人公を描く前に呼ぶ。 ゲームの状態は変えない (描画の揺れだけ)。
 */
const stopSeen = new WeakMap<object, number>()
const kicked = new WeakSet<object>()
/** 髪の跳ね上げの割合 (0〜1)。 止めの前半で 1 まで上がり、明けてから滑らかに 0 へ。 */
export function kesakiHairLift(c: KesakiClock): number {
  if (c.inStop) return easeOut(clamp01(c.stopP / 0.45))
  return 1 - smooth(c.age / 0.28)
}
export function kickKesakiHair(spark: Spark, c: KesakiClock, facing: 1 | -1, hitStopRemaining: number): void {
  const lift = kesakiHairLift(c)
  if (lift > 0.005) {
    const L = KESAKI.lift
    nudgeSpinePlayerBones({ ponytail1: L.deg * L.ponytail1 * lift, ponytail2: L.deg * L.ponytail2 * lift })
  }
  if (c.age > 0.1) return
  if (!kicked.has(spark)) {
    kicked.add(spark)
    const k = 1
    kickSpinePlayerPhysics(facing * KESAKI.kick.x * k, KESAKI.kick.y * k, facing)
  }
  if (c.inStop) {
    const prev = stopSeen.get(spark)
    if (prev !== undefined && prev > hitStopRemaining) addSpinePlayerPhysicsTime((prev - hitStopRemaining) * KESAKI.stopPhysicsRate)
    stopSeen.set(spark, hitStopRemaining)
  }
}

/** 接点の小さく強い白い光 (輪郭を持たないにじみ)。 drawFx から呼ぶ (今の光の雲・火の粉の代わり)。 */
export function drawKesakiContact(ctx: CanvasRenderingContext2D, spark: Spark, c: KesakiClock): void {
  const e = kesakiContactEnv(c)
  if (e <= 0.01) return
  const r = 22
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  const g = ctx.createRadialGradient(spark.x, spark.y, 0, spark.x, spark.y, r)
  const [cr, cg, cb] = KESAKI_COLOR.contact
  for (let i = 0; i <= 8; i++) g.addColorStop(i / 8, `rgba(${cr},${cg},${cb},${(e * Math.pow(1 - i / 8, 2.6)).toFixed(3)})`)
  ctx.fillStyle = g
  ctx.fillRect(spark.x - r, spark.y - r, r * 2, r * 2)
  ctx.restore()
}

/**
 * 床の照り返し: 接点の真下の床が白く照る (白黒の間だけ・色が戻るのと一緒に消える)。 縁を持たないにじみを横長に潰して床に置く (輪は描かない)。
 *   床の後・人物の前 (世界座標の ctx) に呼ぶ。
 */
export function drawKesakiFloorGlow(ctx: CanvasRenderingContext2D, spark: Spark, c: KesakiClock, floorY: number): void {
  const e = kesakiLightEnv(c)
  if (e <= 0.01) return
  const R = 170
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  ctx.translate(spark.x, floorY); ctx.scale(1, 0.22)
  const g = ctx.createRadialGradient(0, 0, 0, 0, 0, R)
  const [cr, cg, cb] = KESAKI_COLOR.floor
  for (let i = 0; i <= 8; i++) g.addColorStop(i / 8, `rgba(${cr},${cg},${cb},${(0.26 * e * Math.pow(1 - i / 8, 1.6)).toFixed(3)})`)
  ctx.fillStyle = g
  ctx.fillRect(-R, -R, R * 2, R * 2)
  ctx.restore()
}

// ---- 宝石と壁の影 (kesaki-shadow だけ) ----------------------------------------------------------------
/** 護拳の中心の宝石 (世界座標)。 */
export function kesakiGemPoint(foot: PlayerFoot): { x: number; y: number } | null {
  const g = spinePlayerRapierPoints()
  return g ? toWorld(foot, g.grip) : null
}
export function kesakiGemEnv(c: KesakiClock): number {
  const top = 1
  if (c.inStop) return top * (0.4 + 0.6 * easeOut(c.stopP))
  return top * (1 - smooth(c.age / 0.34))
}
/** 宝石の灯 (小さなにじみ)。 主人公の後に描く。 */
export function drawKesakiGem(ctx: CanvasRenderingContext2D, _spark: Spark, c: KesakiClock, foot: PlayerFoot): void {
  const g = kesakiGemPoint(foot)
  const e = kesakiGemEnv(c)
  if (!g || e <= 0.01) return
  const r = 11
  ctx.save()
  ctx.globalCompositeOperation = 'lighter'
  const grad = ctx.createRadialGradient(g.x, g.y, 0, g.x, g.y, r)
  const [cr, cg, cb] = KESAKI_COLOR.gem
  for (let i = 0; i <= 8; i++) grad.addColorStop(i / 8, `rgba(${cr},${cg},${cb},${(e * Math.pow(1 - i / 8, 2)).toFixed(3)})`)
  ctx.fillStyle = grad
  ctx.fillRect(g.x - r, g.y - r, r * 2, r * 2)
  ctx.restore()
}

let shadowSmall: HTMLCanvasElement | undefined
const SHADOW_DOWNSCALE = 3
/**
 * 奥の壁の二人の影。 前のコマで描いた体の絵 (drawKesakiLitBody が残した物) を黒く塗り、宝石の真下の床の少し下を
 *   中心に大きく広げて描く (影は人物の 2 倍強・壁の高い所まで届く)。 体より先 (床の後) に、世界座標の ctx で呼ぶ。
 *   縮めた絵を引き伸ばすので輪郭は柔らかい (ぼかしの計算は使わない)。 前のコマの体の絵が無いコマ (弾いた最初のコマ) は描かない。
 */
export function drawKesakiWallShadows(ctx: CanvasRenderingContext2D, _spark: Spark, c: KesakiClock, gem: { x: number; y: number } | null, floorY: number): void {
  if (typeof document === 'undefined' || !gem) return
  const t0 = now()
  const { scale, alpha } = kesakiShadow(c)
  const env = kesakiGemEnv(c)
  const m = ctx.getTransform()
  const W = ctx.canvas.width, H = ctx.canvas.height
  // 壁の照り (宝石の色の弱いにじみ・画面全体は染めない)。
  if (env > 0.01) {
    const gc = m.transformPoint(gem), R = 360 * Math.hypot(m.a, m.b)
    ctx.save(); ctx.resetTransform(); ctx.globalCompositeOperation = 'lighter'
    const grad = ctx.createRadialGradient(gc.x, gc.y, 0, gc.x, gc.y, R)
    const [cr, cg, cb] = KESAKI_COLOR.wall
    for (let i = 0; i <= 8; i++) grad.addColorStop(i / 8, `rgba(${cr},${cg},${cb},${(0.32 * env * Math.pow(1 - i / 8, 1.4)).toFixed(3)})`)
    ctx.fillStyle = grad; ctx.fillRect(gc.x - R, gc.y - R, R * 2, R * 2); ctx.restore()
  }
  if (alpha > 0.01) {
    const anchor = m.transformPoint({ x: gem.x, y: floorY + 30 })
    shadowSmall ??= document.createElement('canvas')
    const sw = Math.ceil(W / SHADOW_DOWNSCALE), sh = Math.ceil(H / SHADOW_DOWNSCALE)
    if (shadowSmall.width !== sw) shadowSmall.width = sw
    if (shadowSmall.height !== sh) shadowSmall.height = sh
    const s = shadowSmall.getContext('2d')!
    s.globalCompositeOperation = 'source-over'; s.clearRect(0, 0, sw, sh)
    let any = false
    for (const role of ['boss', 'player'] as const) {
      const body = bodyCanvas[role]
      if (!body || bodyCaptured[role] !== frameSerial - 1) continue
      s.drawImage(body, 0, 0, sw, sh); any = true
    }
    if (any) {
      s.globalCompositeOperation = 'source-in'
      const [cr, cg, cb] = KESAKI_COLOR.shadow
      s.fillStyle = `rgb(${cr},${cg},${cb})`; s.fillRect(0, 0, sw, sh)
      ctx.save(); ctx.resetTransform()
      ctx.translate(anchor.x, anchor.y); ctx.scale(scale, scale); ctx.translate(-anchor.x, -anchor.y)
      ctx.globalAlpha = alpha
      ctx.drawImage(shadowSmall, 0, 0, W, H)
      ctx.restore()
    }
  }
  if (import.meta.env.DEV) kesakiCost.shadowMs += now() - t0
}
